import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'upsc-continuous-customs-bonds',
  templateUrl: './continuous-customs-bonds.component.html',
  styleUrls: ['./continuous-customs-bonds.component.scss']
})
export class ContinuousCustomsBondsComponent implements OnInit {

  ngOnInit(): void {
  }
}
